export default __webpack_public_path__ + "static/attach-4f35ee099406e1f63073bfd5463fee1a.png";